import { DetailSection } from "../../../detail-section";
import { DetailTabela } from "../../../detail-tabela";
import type { ThrustersSectionViewModel } from "./types-thrusters-section";

export function ThrustersSectionView({
  id,
  title,
  testId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  tabela,
}: ThrustersSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailTabela {...tabela} />
    </DetailSection>
  );
}
